export default "__VITE_ASSET__COCpFcdD__"